import { EntityRequestExpenses } from "../../entity/EntityRequestExpenses";

export class DtoRequestExpensessPostRes extends EntityRequestExpenses {}
